//Javascript for the WECAN Employer Vacancy List
app.VacancyList = (
    function () {
        var vacancies = {
            //Index Page
            Index: function () {
                toastr.options = {
                    "preventDuplicates": true
                };
                app.VacancyList.SetStaffTypeDropDowns();
                app.VacancyList.BindStaffTypeDropdownFunctionality();
                app.VacancyList.InitGridButtons();
                $("#archiveVacancyButton").on("click", function () {
                    var id = $(this).attr("data-vacancy-id");
                    $.ajax({
                        type: "POST",
                        data: { Id: id },
                        url: "/Employer/Vacancy/ArchiveVacancy",
                        success: function (data) {
                            if (data) { //close modal
                                $("#archiveVacancy").modal("hide");
                                //filter grid again for new html
                                app.page.components["VacancyList"][0].refreshGrid();
                                toastr.success("The vacancy status has been archived");
                            }
                            else {
                                toastr.error("Something went wrong");
                            }
                        },
                        error: function () {
                            toastr.error("Something went wrong");
                        }
                    });
                });

                $("#closeVacancyButton, #openVacancyButton, #closeDateModalButton").on("click", function () {
                    var id = $(this).attr("data-vacancy-id");
                    var thisId = $(this).attr("id");
                    $.ajax({
                        type: "POST",
                        data: { Id: id },
                        url: "/Employer/Vacancy/ToggleVacancyStatus",
                        success: function (data) {
                            if (data) {
                                if (thisId === "closeVacancyButton") {
                                    $("#closeVacancy").modal("hide");
                                } else if (thisId === "openVacancyButton") {
                                    $("#openVacancy").modal("hide");
                                } else if ("#closeDateModalButton") {
                                    $("#closeDateModal").modal("hide");
                                }
                                //filter grid again for new html
                                app.page.components["VacancyList"][0].refreshGrid();
                                toastr.success("The vacancy status has changed");
                            }
                            else {
                                toastr.error("Something went wrong");
                            }
                        },
                        error: function () {
                            toastr.error("Something went wrong");
                        }
                    });

                });

                $(document).on("component-bind-view-mode-complete-VacancyList",
                    function () {
                        app.VacancyList.InitGridButtons();
                    });

                $("#resetFiltersButton").on("click", function () {
                    $("#SelectedVacancyStatusId").val("0");
                    $("#SelectedStaffTypeUniqueId").val("staff-types-certified-staff");
                    $("#SelectedPositionTypeId").val(null);
                    $("#SelectedCertifiedPositionTypeId").val(null);
                    $("#SelectedSupportPositionTypeId").val(null);
                    $("#SelectedVisibility").val(null);
                    $("#SearchText").val(null);
                    $("[aria-sort]").removeAttr("aria-sort");
                    $("[data-target='Id']").attr("aria-sort", "descending");

                    // Clear last sort field so that the sort doesn't persist when resetting filters
                    $("input[Name='LastSortField']").val(null);
                    // Remove all sort stuff before the post
                    $("a[data-role='sort-action']").removeClass("desc");
                    $("a[data-role='sort-action']").removeClass("asc");
                    $("a[data-role='sort-action']").removeAttr("aria-sort");
                    $("a[data-role='sort-action']").removeData("role");
                    $("select[name='PageSize']").val("50");

                    // refresh grid
                    app.page.components["VacancyList"][0].refreshGrid();
                });
            },
            SetStaffTypeDropDowns: function () {
                // util.console.log("inside SetStaffTypeDropDowns");

                var selectedValue = $("#SelectedStaffTypeUniqueId :selected").val();
                var certifiedPositionsDropDownDiv = $("#certifiedPositionsDropDownDiv");
                var supportPositionsDropDownDiv = $("#supportPositionsDropDownDiv");
                var certifiedPositionsDropDown = $("#SelectedCertifiedPositionTypeId");
                var supportPositionsDropDown = $("#SelectedSupportPositionTypeId");
                var allPositionsDropDownDiv = $("#allPositionsDropDownDiv");
                var allPositionsDropDown = $("#SelectedPositionTypeId");

                // util.console.log("selectedValue: " + selectedValue);

                switch (selectedValue) {
                    case "staff-types-certified-staff":
                        supportPositionsDropDownDiv.hide();
                        $(supportPositionsDropDown).val(null);
                        allPositionsDropDownDiv.hide();
                        $(allPositionsDropDown).val(null);
                        certifiedPositionsDropDownDiv.show();
                        break;
                    case "staff-types-support-staff":
                        supportPositionsDropDownDiv.show();
                        certifiedPositionsDropDownDiv.hide();
                        $(certifiedPositionsDropDown).val(null);
                        allPositionsDropDownDiv.hide();
                        $(allPositionsDropDown).val(null);
                        break;
                    default:
                        supportPositionsDropDownDiv.hide();
                        $(supportPositionsDropDown).val(null);
                        certifiedPositionsDropDownDiv.hide();
                        $(certifiedPositionsDropDown).val(null);
                        allPositionsDropDownDiv.show();
                        break;
                }
            },
            InitGridButtons: function () {
                $(".openVacancy").on("click",
                    function () {

                        var vacancyId = $(this).data("vacancy-id");
                        var closeDateString = $(this).closest('tr').find('td[data-label="CloseDateString"]').text().trim();

                        // Check if closeDateString is a valid date


                        var closeDate = new Date(closeDateString);
                        var now = new Date();
                        var cstOffset = -6 * 60; // CST timezone offset in minutes
                        var closeDateCST = new Date(closeDate.getTime() + cstOffset * 60000);
                        if (isNaN(closeDateCST.getTime()) || ((now.getTime() <= closeDateCST.getTime()))) {
                            $("#openVacancyButton").attr("data-vacancy-id", vacancyId);
                            $("#openVacancy").modal("show");
                        }
                        else if (now.getTime() > closeDateCST.getTime()) {
                            $("#closeDateModalButton").attr("data-vacancy-id", vacancyId);
                            $("#closeDateModal").modal("show");
                        }



                        //get the archive modal and set the vacancy Id

                    });

                $(".closeVacancy").on("click",
                    function () {
                        var vacancyId = $(this).data("vacancy-id");
                        //get the archive modal and set the vacancy Id
                        $("#closeVacancyButton").attr("data-vacancy-id", vacancyId);
                        $("#closeVacancy").modal("show");
                    });

                $(".archiveVacancy").on("click",
                    function () {
                        var vacancyId = $(this).data("vacancy-id");
                        //get the archive modal and set the vacancy Id
                        $("#archiveVacancyButton").attr("data-vacancy-id", vacancyId);
                        $("#archiveVacancy").modal("show");
                    });

                $(".duplicateVacancy").on("click",
                    function () {
                        var vacancyId = $(this).data("vacancy-id");
                        //get the duplicate modal and set the vacancy Id
                        $("#duplicateVacancyButton").attr("data-vacancy-id", vacancyId);
                        $("#confirmDuplicateVacancy").modal("show");
                    });
            },
            BindStaffTypeDropdownFunctionality: function () {
                //If the vacancy is not closed do not allow them to click archive
                $("#SelectedStaffTypeUniqueId").on("change",
                    function (index, value) {
                        app.VacancyList.SetStaffTypeDropDowns();
                    });
            },
            BulkActionGrid: function () {

                function checkCheckboxes() {
                    if ($("input:checkbox:checked").length > 0) {

                        $("#btnBulkReOpen").prop("disabled", false);
                        $("#btnBulkClose").prop("disabled", false);
                        $("#btnBulkArchive").prop("disabled", false);
                    }
                    else {
                        $("#btnBulkReOpen").prop("disabled", true);
                        $("#btnBulkClose").prop("disabled", true);
                        $("#btnBulkArchive").prop("disabled", true);
                    }
                }

                $(document).on("component-bind-view-mode-complete-BulkActionGrid",
                    function () {
                        $(".BulkUpdateCheckbox, #gridSelectAllBulkUpdate").on("change",
                            function () {
                                checkCheckboxes();
                            });

                        checkCheckboxes();

                        // show/hide the proper bulk action buttons based on the selected vacancy status

                        // open: show close button
                        // closed: show re-open and archive buttons
                        // archived: do not show either button

                        var status = $("#SelectedVacancyStatus option:selected").text();

                        if (status === "Open") {
                            $("#btnBulkReOpen").hide();
                            $("#btnBulkClose").show();
                            $("#btnBulkArchive").hide();
                        } else if (status === "Closed") {
                            $("#btnBulkReOpen").show();
                            $("#btnBulkClose").hide();
                            $("#btnBulkArchive").show();
                        } else if (status === "Archived") {
                            $("#btnBulkReOpen").hide();
                            $("#btnBulkClose").hide();
                            $("#btnBulkArchive").hide();
                        }
                    });

                app.page.components["BulkActionGrid"][0].refreshGrid();

                $("#btnBulkReOpen, #btnBulkClose, #btnBulkArchive").on("click",
                    function (e) {

                        var buttonId = e.target.getAttribute("id");
                        $("#confirmBulkActionButton").attr("data-action", buttonId);

                        // show the modal
                        $("#confirmBulkActionModal").modal("show");


                        $("#confirmBulkActionButton").on("click",
                            function () {
                                var action = $("#confirmBulkActionButton").attr("data-action");
                                // util.console.log("action: " + action);

                                var vacancyIds = $("input:checked:not(#gridSelectAllBulkUpdate)").map(function () {
                                    return this.value;
                                }).get();

                                // util.console.log(vacancyIds);

                                var url = "";

                                if (action === "btnBulkReOpen") {
                                    url = "/Employer/Vacancy/BulkActionReOpen";
                                } else if (action === "btnBulkClose") {
                                    url = "/Employer/Vacancy/BulkActionClose";
                                } else if (action === "btnBulkArchive") {
                                    url = "/Employer/Vacancy/BulkActionArchive";
                                }

                                $.ajax({
                                    type: "POST",
                                    url: url,
                                    data: { vacancyIds: vacancyIds },
                                    success: function (data) {
                                        toastr.success("Success!");
                                        app.page.components["BulkActionGrid"][0].refreshGrid();
                                        $("#confirmBulkActionModal").modal("hide");

                                        // remove button event handler to prevent duplicate handlers being created
                                        $("#confirmBulkActionButton").off("click");
                                    },
                                    error: function (data) {
                                        toastr.error("There was an error with the bulk update. Please try again.");
                                        $("#confirmBulkActionButton").off("click");
                                    }
                                });
                            });
                    });
            }
        };

        return vacancies;
    }()
);